import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
import { SearchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import MobileSearch from "@SupplyLand/Widgets/Header/MobileSearch";
import React from "react";
import { css } from "styled-components";

export interface SearchCartProfileStyles {
    searchInputStyles?: SearchInputStyles;
    container?: InjectableCss;
    mobileSearchWrapper?: HiddenProps;
    mobileProfileWrapper?: HiddenProps;
    mobileCartWrapper?: HiddenProps;
    searchInputWrapper?: HiddenProps;
}

export const searchCartProfileStyles: SearchCartProfileStyles = {
    container: {
        css: css`
            display: flex;
            height: 100%;
            justify-content: space-evenly;
            align-items: center;
        `,
    },
    mobileSearchWrapper: {
        css: css``,
    },
    mobileProfileWrapper: {
        css: css``,
    },
    mobileCartWrapper: {
        css: css``,
    },
    searchInputWrapper: {
        css: css``,
    },
};

export const SearchCartProfile: React.FC<WidgetProps & { isAnimated?: boolean }> = ({ id, isAnimated = false }) => {
    const styles = useMergeStyles("headerSearchInput", searchCartProfileStyles);

    return (
        <StyledWrapper {...styles.container}>
            <Hidden above="md" {...styles.mobileSearchWrapper}>
                <MobileSearch {...styles.mobileSearch} />
            </Hidden>
            <Hidden above="md" {...styles.mobileProfileWrapper} data-test-selector="mobileProfileWrapper">
                <Zone contentId={id} zoneName="MobileProfileZone" />
            </Hidden>
            <Hidden above="md" {...styles.mobileCartWrapper} data-test-selector="mobileCartWrapper">
                <Zone contentId={id} zoneName="MobileCartZone" />
            </Hidden>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: SearchCartProfile,
    definition: {
        group: "Header",
        displayName: "Search Cart and Profile for Mobile",
    },
};

export default widgetModule;
